import illustration from "../../assets/images/illustration-hero.svg";

export const heroData = {
  header: "A Simple Bookmark Manager",
  subheader:
    "A clean and simple interface to organize your favourite websites. Open a new browser tab and see your sites load instantly. Try it for free.",
  button1: {
    text: "Get it on Chrome",
    link: "/",
  },
  button2: {
    text: "Get it on Firefox",
    link: "/",
  },
  image: illustration,
  imageAlt: "a web app displayed by a monitor screen"
};
